import { formatPrice, formatNumber } from '@app/libs/format'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'

const CustomFooter = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  alignSelf: 'center',
})

export default function Footer({ getValues }) {
  const { t } = useTranslation()

  const { standard, premium } = getValues('data')

  const sizeObject = (obj) => {
    let size = 0
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) size++
    }
    return size
  }

  const totalEstimateCost = (obj) => {
    let sum = 0
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        sum += obj[key]['estimateCost']
      }
    }
    return sum
  }

  const totalQuantityCodes = (obj) => {
    let sum = 0
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        sum += Number(obj[key]['quantityCodes'])
      }
    }
    return sum
  }

  return (
    <>
      <Grid container p={4}>
        <Grid item xs={10}>
          <Grid container>
            <CustomFooter item xs={4}>
              <Grid container>
                <Grid item xs={5}>
                  <Typography sx={{ fontWeight: 600 }}>{t('CART.TOTAL_VOUCHERS')}:</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography sx={{ color: '#3f51b5' }}>
                    {formatNumber(sizeObject(premium) + sizeObject(standard))}
                  </Typography>
                </Grid>
              </Grid>
            </CustomFooter>
            <CustomFooter item xs={4}>
              <Grid container>
                <Grid item xs={5}>
                  <Typography sx={{ fontWeight: 600 }}>{t('CART.TOTAL_SELECTED_CODES')}:</Typography>
                </Grid>
                <CustomFooter item xs={7}>
                  <Typography sx={{ color: '#3f51b5' }}>{formatNumber(totalQuantityCodes(premium))}</Typography>
                </CustomFooter>
              </Grid>
            </CustomFooter>
            <CustomFooter item xs={4}>
              <Grid container>
                <Grid item xs={5}>
                  <Typography sx={{ fontWeight: 600 }}>{t('CART.TOTAL_PRICES')}:</Typography>
                </Grid>
                <CustomFooter item xs={7}>
                  <Typography sx={{ color: '#3f51b5' }}>{formatPrice(totalEstimateCost(premium))}</Typography>
                </CustomFooter>
              </Grid>
            </CustomFooter>
          </Grid>
        </Grid>
        <CustomFooter item xs={2}>
          <Grid container justifyContent="center">
            <Button type="submit" variant="contained">
              {t('CART.CREATE_CAMPAIGN')}
            </Button>
          </Grid>
        </CustomFooter>
      </Grid>
    </>
  )
}
